import shave from 'shave';

import isMobile from '../../../resources/scripts/helpers/is-mobile';

class BrixPostArchive {
  static init(...parameters) {
    return new BrixPostArchive(...parameters);
  }

  constructor(block) {
    this.preamble = block.querySelectorAll('.preamble');
    this.header = block.querySelectorAll('.h4');
    this.filterForm = block.querySelector('.filter-form');
    this.filterBackground = block.querySelector('.filter-background');
    this.filterDropdown = this.filterForm.querySelector('.filter-dropdown');
    this.selectedOption = this.filterForm.querySelector('.selected-option');
    this.filterOptions = this.filterDropdown.querySelectorAll('.filter-options');

    if (this.preamble && this.header) {
      this.truncateEventTitle();
    }

    this.addEventListeners();
  }

  truncateEventTitle() {
    if (isMobile()) {
      Array.from(this.header).forEach((title) => {
        shave(title, 60);
      });
    } else {
      Array.from(this.header).forEach((title) => {
        shave(title, 30);
      });
      Array.from(this.preamble).forEach((title) => {
        shave(title, 110);
      });
    }
  }

  addEventListeners() {
    if (this.selectedOption) {
      this.selectedOption.addEventListener('click', (e) => {
        e.preventDefault();
        this.filterDropdown.classList.add('-visible');
        this.filterBackground.classList.add('-visible');

        if (this.filterBackground) {
          this.filterBackground.addEventListener('click', () => {
            this.filterDropdown.classList.remove('-visible');
            this.filterBackground.classList.remove('-visible');
          });
        }
      });
    }

    this.filterForm.addEventListener('submit', (e) => {
      if (e.submitter.classList.contains('-active')) {
        e.preventDefault();
        return false;
      } if (e.submitter.dataset.value === 'all') {
        const { baseUrl } = this.filterDropdown.dataset;
        window.location.href = `${window.location.origin}${baseUrl}`;
      } else {
        this.filterForm.submit();
      }
      return true;
    });

    if (this.filterDropdown) {
      [...this.filterOptions].forEach((filterOption) => {
        filterOption.addEventListener('click', (e) => {
          if (e.target.dataset.value === 'all') {
            const { baseUrl } = this.filterDropdown.dataset;
            window.location.href = `${window.location.origin}${baseUrl}`;
          } else {
            this.filterForm.submit();
          }
        });
      });
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-post-archive', BrixPostArchive.init);
}
